"use strict";
// ПОДКЛЮЧЕНИЕ
// Вы можете смешивать require и export.
// Вы не можете смешивать import и module.exports.

import Swiper from "swiper";
import SwiperCore, {Navigation, Pagination} from "swiper/core";
SwiperCore.use([Navigation, Pagination]);

import flatpickr from "flatpickr";
import {Russian} from "flatpickr/dist/l10n/ru.js";
flatpickr.localize(Russian);

import IMask from "imask";

import mobileMenu from "./mobileMenu";
import stickyHeader from "./stickyHeader";
import timer from "./timer";
import customSelect from "./customSelect";
import setScrollWidth from "./setScrollWidth";
import openModal from "./openModal";
import resizeVideoPlayer from "./resizeVideoPlayer";
import cart from "./cart/cart";
import hideFixibleElement from "./hideFixibleElement";
import tabs from "./tabs";
import addFavorite from "./addFavorite";
import showAll from "./showAll";
import showMore from "./showMore/showMore";
import forms from "./forms/forms";
import searchAutocomplite from "./autocomplite";
import showMobileSearch from "./showMobileSearch";
import location from "./getLocation/getLocation";
import phoneMask from "./phoneMask";
import filters from "./filters/filters";
import {closePopup} from "./closePopup";
import {changeAddress} from "./changeAddress/changeAddress";
import {checkProductCategory} from "./checkProductCategory";

// Отключил
// import openSort from "./openSort";
// Показ сортировки
// if (window.matchMedia("(max-width: 1199px)").matches) {
//   openSort({});
// }

// НАСТРОЙКИ

// Высчитываем ширину скролла
setScrollWidth();

// Мобильное меню
mobileMenu({
  btnOpenTag: ".js-menu-open",
  btnCloseTag: ".js-menu-close",
  bodyClass: "menu-open",
  closeAnimate: true,
  isHeader: true,
  animateElementSelector: ".js-menu-animate",
});

// Мобильный фильтр
mobileMenu({
  btnOpenTag: ".js-filters-open",
  btnCloseTag: ".js-filters-close",
  bodyClass: "filters-open",
});

// Липкая шапка
stickyHeader();

// Таймер акций
timer();

// Кастомный селект
customSelect({
  activeItemClass: `select__item--active`,
});

// открытие модальных окон
if (window.matchMedia("(max-width: 767px)").matches) {
  openModal({});
}

openModal({
  containerSelector: `.js-modal-container-comments`,
});

openModal({
  containerSelector: `.js-modal-container-item`,
  overflowBodyClass: `modal-item-open`,
});

// Закрытие открытого на бэке модального окна
closePopup();

// Скрытие нижнего меню на страницах Товара и Корзины
if (window.matchMedia("(max-width: 767px)").matches) {
  hideFixibleElement({});
} else {
  hideFixibleElement({fixibleSelector: `.js-bottom-fix-tablet`});
}

// ресайз высоты видео плеера
resizeVideoPlayer({});

// Слайдеры
const swiper = new Swiper(`.swiper-container`, {
  slidesPerView: "auto",
  freeMode: true,
  spaceBetween: 29,
  breakpoints: {
    1200: {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
});

const hideButton = (button) => {
  if (button) {
    const parent = button.closest(`.slider__side-bg`);
    parent.classList.add(`hide`);
  }
};

const showButton = (button) => {
  if (button) {
    const parent = button.closest(`.slider__side-bg`);
    parent.classList.remove(`hide`);
  }
};

const swiperCollections = new Swiper(`.swiper-container-collections`, {
  slidesPerView: "auto",
  freeMode: true,
  spaceBetween: 15,
  breakpoints: {
    768: {
      spaceBetween: 22,
    },
    1200: {
      freeMode: false,
      spaceBetween: 22,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  },
  on: {
    afterInit: function () {
      if (this.isBeginning && this.isEnd) {
        hideButton(this.navigation.prevEl);
        hideButton(this.navigation.nextEl);
      }
    },
    reachBeginning: function () {
      if (this.navigation.prevEl) {
        hideButton(this.navigation.prevEl);
      }
    },
    reachEnd: function () {
      if (this.navigation.nextEl) {
        hideButton(this.navigation.nextEl);
      }
    },
    transitionStart: function () {
      if (!this.isBeginning) {
        showButton(this.navigation.prevEl);
      }
      if (!this.isEnd) {
        showButton(this.navigation.nextEl);
      }
    },
  },
});

const swiperStock = new Swiper(`.swiper-container-stock`, {
  slidesPerView: "auto",
  freeMode: true,
  spaceBetween: 22,
  breakpoints: {
    768: {
      loop: true,
      freeMode: false,
      spaceBetween: 89,
      navigation: {
        nextEl: ".swiper-button-next",
      },
    },
    1200: {
      loop: true,
      freeMode: false,
      spaceBetween: 102,
      navigation: {
        nextEl: ".swiper-button-next",
      },
    },
  },
  on: {
    beforeInit: () => {
      document.body.classList.add(`stock-slider-init`);
    },
  },
});

const swiperAuthors = new Swiper(`.swiper-container-authors`, {
  slidesPerView: "auto",
  freeMode: true,
  spaceBetween: 22,
  breakpoints: {
    768: {
      spaceBetween: 38,
    },
    1200: {
      loop: true,
      freeMode: false,
      spaceBetween: 108,
      navigation: {
        nextEl: ".swiper-button-next",
      },
    },
  },
});

const swiperItem = new Swiper(`.swiper-container-item`, {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1200: {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        bulletClass: `swiper-pagination-preview`,
        bulletActiveClass: `swiper-pagination-active`,
        renderBullet: function (index, className) {
          return `<span class="${className}"><img src="${this.imagesToLoad[index].src}" width="65" height="65" class="${className}-img"></span>`;
        },
      },
    },
  },
  on: {
    afterInit: function () {
      const bullets = this.pagination.bullets;

      if (bullets.length > 1) {
        bullets.forEach((element, index) => {
          element.addEventListener(`mouseenter`, () => {
            this.slideTo(index, 200);
          });
        });
      } else {
        this.navigation.destroy();
        this.pagination.destroy();
        this.disable();
      }
    },
  },
});

const swiperBlog = new Swiper(`.swiper-container-blog`, {
  slidesPerView: 1,
  spaceBetween: 1,
  pagination: {
    el: ".swiper-pagination-blog",
    clickable: true,
  },
});

if (window.matchMedia("(max-width: 1199px)").matches) {
  const swiperFeatures = new Swiper(`.swiper-container-features`, {
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
    },
  });
}

// Получение цены на странице товара
cart({});

// Табы
tabs({});

// Добавление datepicker
flatpickr(`.js-flatpicker`, {
  altInput: true,
  altFormat: "D j F Y",
  dateFormat: "Y-m-d",
  monthSelectorType: "static",
  defaultDate: new Date(),
  minDate: new Date(),
  static: true,
});

// Добавление в избранное
addFavorite({});

// Показать всё
// фильтры
showAll({});
// тэги
showAll({
  containerSelector: `.js-show-all-tags`,
  visibleCount: 6,
  ButtonLabels: {
    SHOW: `Все тэги`,
    HIDE: `Скрыть`,
  },
});

// Показать ещё
showMore({});

// Формы
// Консультация
forms({});
// Reviews
forms({formSelector: `.js-form-review`});
// Order
forms({formSelector: `.js-form-order`, enabledAddFiles: false, enabledPost: false});

// autocomplite
searchAutocomplite({});

// Открытие поиска
showMobileSearch({});

// Маска для телефона
phoneMask({IMask});

// Определение локации
location({});

// Работа с фильтрами категорий
filters({IMask});

changeAddress();

checkProductCategory();
